export var API_BASE_URL = 'https://api.alwayson.ai/v1';
export var getApiDomainFromElement = function () {
    var elScript = document.getElementById("alwayson_chatbot_script");
    if (!elScript)
        throw new Error('Chatbot script element id "#alwayson_chatbot_script" not found!');
    var srcString = elScript.getAttribute('src') || '';
    var urlSearchParams = new URLSearchParams(srcString.split("?")[1] || '');
    return urlSearchParams.get('api_domain') || 'api.alwayson.ai';
};
export var getApiBaseUrl = function () {
    var apiDomain = getApiDomainFromElement();
    if (apiDomain) {
        return window.location.protocol + '//' + apiDomain + '/v1';
    }
    return API_BASE_URL;
};
export var CHAT_BOT_POSITION_LEFT = 'left';
export var CHAT_BOT_POSITION_RIGHT = 'right';
